<script>
    import {Button, Modal} from "flowbite-svelte";
import {globalConfirm} from "$lib/stores/modal";


</script>

<Modal bind:open={$globalConfirm.open}>
    <p>{$globalConfirm.content}</p>
    <div class="grid grid-cols-2 gap-12 mt-3">
        <Button on:click={() => $globalConfirm.open = false} color="red">Nein</Button>
        <Button on:click={() => {$globalConfirm._()}}    color="green">Ja</Button>
    </div>
</Modal>